// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCA8NQP9o187RiUbEkdU6kaKNlLIq5YW9Y",
  authDomain: "pip-college.firebaseapp.com",
  databaseURL: "https://pip-college-default-rtdb.firebaseio.com",
  projectId: "pip-college",
  storageBucket: "pip-college.appspot.com",
  messagingSenderId: "667180281365",
  appId: "1:667180281365:web:6b5ab8c6eb7751946ce81c",
  measurementId: "G-57V7H4XETC"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Initialize Firestore
const db = getFirestore(app);

// Initialize Firebase Authentication
const auth = getAuth(app);

export { db, auth, analytics };